import { Injectable } from '@angular/core';
import { AppConfig } from './app-config.interface';
import { allAppConfigs } from './app.config';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  private readonly config: AppConfig;

  constructor() {
    const configId = environment.configId;
    this.config = allAppConfigs[configId];
  }

  getConfig(): AppConfig {
    return this.config;
  }
}